// RTK Query slice for contacts
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const contactsApi = createApi({
  reducerPath: "contactsApi",
  baseQuery: dynamicBaseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 1800,
  tagTypes: ["Contacts"],
  endpoints: (builder) => ({
    getContacts: builder.query({
      query: () => ({
        url: "api/contacts",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      transformResponse: (response) => {
        // Response already comes with correct structure from backend
        return response.map((contact) => ({
          id: contact.id,
          firstName: contact.firstName || "",
          lastName: contact.lastName || "",
          name: `${contact.firstName} ${contact.lastName}`.trim() || "Unknown",
          email: contact.email,
          phone: contact.phone || "",
          visits: contact.totalVisits || 0,
          noShows: contact.noShows || 0,
          lastVisit: contact.lastVisit,
          firstVisit: contact.firstVisit,
          status: contact.status || "Active",
        }));
      },
      providesTags: ["Contacts"],
    }),

    getContactById: builder.query({
      query: (id) => ({
        url: `api/contacts/${id}`,
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      transformResponse: (response) => ({
        id: response.id,
        firstName: response.firstName || "",
        lastName: response.lastName || "",
        name: `${response.firstName} ${response.lastName}`.trim() || "Unknown",
        email: response.email,
        phone: response.phone || "",
        visits: response.totalVisits || 0,
        noShows: response.noShows || 0,
        lastVisit: response.lastVisit,
        firstVisit: response.firstVisit,
        status: response.status || "Active",
        reservations: response.reservations || [],
      }),
      providesTags: (result, error, id) => [{ type: "Contacts", id }],
    }),
  }),
});

export const { useGetContactsQuery, useGetContactByIdQuery } = contactsApi;
